import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { UserCard } from "components/UserCard/UserCard.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { WEB_URL } from "variables/Variables.jsx";
import avatar from "assets/img/faces/face-3.jpg";
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";

class SetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
        CurrentPassword : '',
        NewPassword : '',
        NewPasswordRepeat : '',
        runningUpdatePasswordOperation : false
    }
  }

  handleUserInput (e) {
        const name = e.target.name;
        const value = e.target.value;
        const targetField = e.target;
    
        this.setState({[name]: value});
  }

  handlePasswordUpdate(e){
    if(this.state.NewPassword == this.state.NewPasswordRepeat){
        var _this = this;
        this.setState({runningUpdatePasswordOperation : true});


        fetch("https://"+WEB_URL+"/account/api/updateuser",{
            'method' : 'POST',
            'headers' : { 'Content-Type' : 'application/json'},
            //'body' : 'token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&action=setpassword&currentpassword='+this.state.CurrentPassword+'&newpassword='+this.state.NewPassword
            'body' : JSON.stringify({'token':this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'action':'setpassword','currentpassword':this.state.CurrentPassword,'newpassword':this.state.NewPassword})
          }).then(res => res.json())
            .then(
              (response) => {
                if(response.result == 'FAILURE'){
                    this.props.triggerNotification('error','tc',response.message);
                }else{
                    this.props.triggerNotification('success','tc','Successfully updated your password.');

                    // triggering log in again so we get a new cookie
                    fetch("https://"+WEB_URL+"/account/api/login",{
                    'method' : 'POST',
                    'headers' : { 'Content-Type' : 'application/json'},
                    //'body' : 'email='+_this.props.authEmail+'&password='+_this.state.NewPassword+'&detail=true',
                    'body' : JSON.stringify({'email':_this.props.authEmail,'pass':_this.state.NewPassword,detail:true}),
                    'credentials': 'same-origin'
                    }).then(res => res.json())
                    .then(
                        (result) => {
                            if(result.auth == 'AUTH_OK'){
                                _this.props.history.push('/home/user');
                                _this.props.setLoggedIn(result,_this.props.authEmail);
                              }else{
                                _this.props.setLoggedIn(false);    
                              }
                        },
                        (error) => {
                          _this.props.setLoggedIn(false);
                        }
                      )
                }

                this.setState({runningUpdatePasswordOperation : false});
              },
              (error) => {
                this.setState({runningUpdatePasswordOperation : false});
              }
            )
    }else{ // new passwords not matching
        this.props.triggerNotification('error','tc','The new passwords do not match. Please check your input. ');
    }

    e.preventDefault();
  }

  render() {
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={8}>
              <Card
                title="Enter current and new password below"
                content={
                  <form>
                    <Row style={{paddingBottom:15}}>
                    <Col md={6} style={{paddingRight:7}}>
                    {<FormInputs
                      ncols={["col-md-12"]}
                      properties={[
                        {
                          label: "Current Password",
                          type: "password",
                          name: "CurrentPassword",
                          bsClass: "form-control",
                          placeholder: "Password",
                          defaultValue: ""
                        }
                      ]}
                      onChange={(event) => this.handleUserInput(event)} 
                    /> }
                    </Col>
                    </Row>
                    <Row style={{paddingBottom:15}}>
                    <Col md={12} style={{paddingRight:7}}>
                    {<FormInputs
                      ncols={["col-md-6", "col-md-6"]}
                      properties={[
                        {
                          label: "New Password",
                          type: "password",
                          name: "NewPassword",
                          bsClass: "form-control",
                          placeholder: "Password",
                          defaultValue: ""
                        },
                        {
                          label: "Repeat Password",
                          type: "password",
                          name: "NewPasswordRepeat",
                          bsClass: "form-control",
                          placeholder: "Confirm Password",
                          defaultValue: ""
                        }
                      ]}
                      onChange={(event) => this.handleUserInput(event)} 
                    /> }
                    </Col>
                    </Row>

                    <ProgressButton runningAsyncOperation={this.state.runningUpdatePasswordOperation}  onClick={(e) => {this.handlePasswordUpdate(e);}} bsStyle="info" fill type="submit">
                      Update Password
                    </ProgressButton>

                    <Button bsStyle="default pull-right" fill type="submit"  onClick={(e) => this.props.history.push('/home/user')}>
                      Cancel
                    </Button>
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default SetPassword;
